import http from '../util/request.js'

export const accountLogList = (params) =>{
	return http({
		url:'/apistore/accountLog/list',
		data:params,
		method:'get'
	})
}

